import { Name } from '@ori-events/open-login';
import type { MouseEvent } from 'react';
import { useCallback, useEffect, useMemo } from 'react';

import { AD_LOGIN_PATH, SSO_IDENTITY_AD_LOGIN_PATH, SSO_IDENTITY_LOGIN_PATH } from '../../constants';
import { Provider } from '../../contexts';
import { goToPage, openLoginSidebar } from '../../utils';
import type { LoginProviderProps } from './types';

/**
 *
 */
export const LoginProvider = ({ children, isSsoIdentityLogin }: LoginProviderProps) => {
  const adLogin = useMemo(
    () => (isSsoIdentityLogin ? SSO_IDENTITY_AD_LOGIN_PATH : AD_LOGIN_PATH),
    [isSsoIdentityLogin],
  );
  const doLogin = useCallback(
    (event?: MouseEvent) => {
      // Ctrl or Cmd key is pressed, redirect to AD login
      if (Boolean(event?.ctrlKey) || event?.metaKey) {
        goToPage(adLogin);

        return;
      }
      // UseSsoIdentityLogin feature is enabled, redirect to SSO_IDENTITY_LOGIN_PATH
      if (isSsoIdentityLogin) {
        goToPage(SSO_IDENTITY_LOGIN_PATH);

        return;
      }
      // UseSsoIdentityLogin feature is disabled, open login sidebar
      openLoginSidebar();
    },
    [adLogin, isSsoIdentityLogin],
  );
  const onLogin = useCallback(() => {
    doLogin();
  }, [doLogin]);

  useEffect(() => {
    window.addEventListener(Name, onLogin);

    return () => {
      window.removeEventListener(Name, onLogin);
    };
  }, [onLogin]);

  return <Provider value={useMemo(() => ({ doLogin }), [doLogin])}>{children}</Provider>;
};
